import React, { useState } from "react";
import { CheckIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";
import { useQuery } from "@apollo/client";
import preAuth from "../../../../gql/preAuth";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function AdmissionSpecialitySearchNSelect({ setFieldValue, error }) {
  const [query, setQuery] = useState("");
  const [selectedPractioner, setSelectedPractioner] = useState(null);

  const [people, setPeople] = useState([]);

  const formatData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.code,
          name: item.display,
          //   receivedDate: item.receivedDate,
          code: item.code,
          description: item.display,
        });
      });
    } else {
    }
    return returnData;
  };

  const {
    loading: loadingItemCodes,
    error: errorItemCodes,
    data: itemCodesData,
    refetch,
  } = useQuery(preAuth.GET_ADMISSION_SPECIALITY_CODES, {
    variables: { q: "abcdefgh*%^%" },
  });

  React.useEffect(() => {
    if (itemCodesData) {
      setPeople(formatData(itemCodesData?.getAddmissionSpecialityCodes?.data));
    }
  }, [itemCodesData]);

  const filteredPeople =
    query === ""
      ? people
      : people.filter((person) => {
          let searched = person.name
            .toLowerCase()
            .includes(query.toLowerCase());
          if (!searched) {
            searched = person.id.toLowerCase().includes(query.toLowerCase());
          }
          return searched;
        });

  const onSearch = (inputText) => {
    setQuery(inputText);
    if (inputText.length > 1) {
      refetch({ q: inputText });
    } else {
    }
  };

  return (
    <Combobox
      as="div"
      value={selectedPractioner}
      onChange={(val) => {
        setSelectedPractioner(val);
        setFieldValue(val);
      }}
    >
      {/* <Combobox.Label className="block text-sm font-medium leading-6 text-gray-900">
              Select Beneficiary
            </Combobox.Label> */}
      <div className="relative">
        <Combobox.Input
          className={`!shadow-none w-full rounded-[6px] pl-[8px] pr-7 py-[5px] border !border-gray-300 !bg-gray-100 text-gray-800 !text-[12px] leading-tight placeholder:text-[12px] placeholder:leading-tight placeholder:!text-gray-700 focus:!ring-0 focus:!ring-primary focus:!border-primary outline-none ${
            error ? "!border-red-500 focus:!ring-red-500" : ""
          }`}
          onChange={(event) => onSearch(event.target.value)}
          // displayValue={(person) => `${person?.name} - ${person?.id}`}
          displayValue={(person) => person?.name}
          placeholder={"Search for Code"}
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2 focus:outline-none">
          <MagnifyingGlassIcon
            className="h-4 w-4 text-gray-400"
            aria-hidden="true"
          />
        </Combobox.Button>

        {filteredPeople.length > 0 && (
          <Combobox.Options className="w-auto absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-[6px] bg-white py-1 text-[12px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xs">
            {filteredPeople.map((person) => (
              <Combobox.Option
                key={person.id}
                value={person}
                className={({ active }) =>
                  classNames(
                    "relative cursor-default select-none py-1.5 pl-3 pr-9",
                    active ? "bg-primary text-white" : "text-gray-900"
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span
                      className={classNames(
                        "block truncate",
                        selected && "font-semibold"
                      )}
                    >
                      {person.name} - {person.id}
                    </span>

                    {selected && (
                      <span
                        className={classNames(
                          "absolute inset-y-0 right-0 flex items-center pr-4",
                          active ? "text-white" : "text-primary"
                        )}
                      >
                        <CheckIcon className="h-4 w-4" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}

export default AdmissionSpecialitySearchNSelect;
